import { render, staticRenderFns } from "./newsletter-unsubscribe.vue?vue&type=template&id=d177b080"
import script from "./newsletter-unsubscribe.vue?vue&type=script&lang=ts"
export * from "./newsletter-unsubscribe.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ElementsFormResponse: require('/usr/src/nuxt-app/components/elements/FormResponse.vue').default})
